import { render, staticRenderFns } from "./AIGenerateMessageItem.vue?vue&type=template&id=4eb0f236&scoped=true&"
import script from "./AIGenerateMessageItem.vue?vue&type=script&lang=js&"
export * from "./AIGenerateMessageItem.vue?vue&type=script&lang=js&"
import style0 from "./AIGenerateMessageItem.vue?vue&type=style&index=0&id=4eb0f236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb0f236",
  null
  
)

export default component.exports